var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUzbekistn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.944406 13.9131C0.331749 15.8324 -4.75936e-05 17.8772 3.05314e-05 19.9998C-4.75936e-05 22.1224 0.331827 24.1674 0.944484 26.0867L20 26.9564L39.0556 26.0869C39.6682 24.1674 40.0001 22.1224 40.0001 19.9999C40 17.8773 39.6682 15.8324 39.0556 13.913L20 13.0435L0.944406 13.9131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0555 13.9131L20 13.0436L0.94437 13.9131C0.762808 14.4822 0.606479 15.0624 0.475464 15.6523H39.5242C39.3933 15.0623 39.2371 14.482 39.0555 13.9131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.475739 24.3477C0.606598 24.9375 0.762926 25.5177 0.944489 26.0867L0.946364 26.0868L20 26.9563L39.0555 26.0868C39.2371 25.5177 39.3934 24.9375 39.5243 24.3477H0.475739Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9998C28.9231 39.9998 36.4801 34.1559 39.0555 26.0868H0.944489C3.51988 34.1558 11.0771 39.9998 20 39.9998V39.9998Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 -0.00012207C11.0769 -4.39445e-05 3.51991 5.84394 0.944366 13.9129L39.0554 13.913C36.4801 5.84386 28.923 -0.000200195 19.9999 -0.00012207V-0.00012207Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13953 8.26087C9.13953 6.38767 10.456 4.82282 12.2141 4.43892C11.9439 4.37985 11.6635 4.3479 11.3755 4.3479C9.21445 4.3479 7.46249 6.09978 7.46249 8.26095C7.46249 10.4221 9.21429 12.174 11.3755 12.174C11.6635 12.174 11.9438 12.142 12.2141 12.083C10.4561 11.6989 9.13953 10.1341 9.13953 8.26087V8.26087Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5268 10.0396L14.7916 10.8548H15.6488L14.9554 11.3587L15.2202 12.1739L14.5268 11.6701L13.8332 12.1739L14.0981 11.3587L13.4046 10.8548H14.2618L14.5268 10.0396Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2628 10.0396L17.5277 10.8548H18.3849L17.6914 11.3587L17.9563 12.1739L17.2628 11.6701L16.5693 12.1739L16.8342 11.3587L16.1407 10.8548H16.9979L17.2628 10.0396Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9988 10.0396L20.2637 10.8548H21.1209L20.4274 11.3587L20.6923 12.1739L19.9988 11.6701L19.3052 12.1739L19.5702 11.3587L18.8766 10.8548H19.7339L19.9988 10.0396Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7349 10.0396L22.9998 10.8548H23.8569L23.1635 11.3587L23.4284 12.1739L22.7349 11.6701L22.0413 12.1739L22.3063 11.3587L21.6127 10.8548H22.4699L22.7349 10.0396Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4706 10.0396L25.7356 10.8548H26.5927L25.8993 11.3587L26.1642 12.1739L25.4706 11.6701L24.7771 12.1739L25.042 11.3587L24.3486 10.8548H25.2057L25.4706 10.0396Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2628 7.19373L17.5277 8.00888H18.3849L17.6914 8.51287L17.9563 9.32802L17.2628 8.82419L16.5693 9.32802L16.8342 8.51287L16.1407 8.00888H16.9979L17.2628 7.19373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9988 7.19373L20.2637 8.00888H21.1209L20.4274 8.51287L20.6923 9.32802L19.9988 8.82419L19.3052 9.32802L19.5702 8.51287L18.8766 8.00888H19.7339L19.9988 7.19373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7349 7.19373L22.9998 8.00888H23.8569L23.1635 8.51287L23.4284 9.32802L22.7349 8.82419L22.0413 9.32802L22.3063 8.51287L21.6127 8.00888H22.4699L22.7349 7.19373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4706 7.19373L25.7356 8.00888H26.5927L25.8993 8.51287L26.1642 9.32802L25.4706 8.82419L24.7771 9.32802L25.042 8.51287L24.3486 8.00888H25.2057L25.4706 7.19373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9988 4.34778L20.2637 5.16309H21.1209L20.4274 5.66692L20.6923 6.48223L19.9988 5.9784L19.3052 6.48223L19.5702 5.66692L18.8766 5.16309H19.7339L19.9988 4.34778Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7349 4.34778L22.9998 5.16309H23.8569L23.1635 5.66692L23.4284 6.48223L22.7349 5.9784L22.0413 6.48223L22.3063 5.66692L21.6127 5.16309H22.4699L22.7349 4.34778Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4706 4.34778L25.7356 5.16309H26.5927L25.8993 5.66692L26.1642 6.48223L25.4706 5.9784L24.7771 6.48223L25.042 5.66692L24.3486 5.16309H25.2057L25.4706 4.34778Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbekistn);
export default __webpack_public_path__ + "static/media/uzbekistán.0423d1957e444e06698983d72dfa72f3.svg";
export { ForwardRef as ReactComponent };